// extracted by mini-css-extract-plugin
export default {"listElement":"CheckList-module--list-element--93e11","listItem":"CheckList-module--list-item--9d6ae","tickImage":"CheckList-module--tick-image--c3235"};